import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import styles from "../../content/pages/homepage.module.css";

export type RankingsFilterValue =
  | "all"
  | "current"
  | "rookies"
  | "draft_prospects";

interface AllRankingsFilterToggleProps {
  selectedFilter: RankingsFilterValue;
  onFilterChange: (filter: RankingsFilterValue) => void;
  availableFilters?: RankingsFilterValue[];
}

const allFilters: { label: string; value: RankingsFilterValue }[] = [
  { label: "ALL", value: "all" },
  { label: "Veterans", value: "current" },
  { label: "Rookies", value: "rookies" },
  { label: "Prospects", value: "draft_prospects" },
];

export default function AllRankingsFilterToggle({ selectedFilter, onFilterChange, availableFilters }: AllRankingsFilterToggleProps) {
  const filters = availableFilters
    ? allFilters.filter((f) => f.value === "all" || availableFilters.includes(f.value))
    : allFilters;

  if (filters.length <= 1) return null;

  return (
    // <Box sx={{ maxWidth: "300px", margin: "auto", }}>
    <>
      <Grid container spacing={0.5} sx={{ pt: 0.5, lineHeight: 1 }}>
        {filters.map(({ label, value }) => (
          <Grid item xs key={value}>
            <Button
              fullWidth
              variant="contained"
              color={selectedFilter === value ? "primary" : "inherit"}
              onClick={() => onFilterChange(value)}
              // className={styles.positionButtonHover}
              sx={{
                borderRadius: "5px",
                padding: "2px 2px",
                minWidth: "20px",
                minHeight: "25px",
                textTransform: "none",
                fontSize: "0.8rem",
                lineHeight: 1.1,
                whiteSpace: "nowrap",
                // Evita que el hover se quede naranja en botones no seleccionados
                "&.MuiButton-containedInherit:hover": {
                  backgroundColor: "#e0e0e0",
                  boxShadow: "none",
                },
                // Mantiene naranja en el seleccionado
                "&.MuiButton-containedPrimary:hover": {
                  backgroundColor: "#ff672d",
                  boxShadow: "none",
                },
              }}
            >
              {label}
            </Button>
          </Grid>
        ))}
      </Grid>
    </>
    // </Box>
  );
}
